// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Close20 from './Close20.tsx';
import Close20Circle from './Close20Circle.tsx';
import Close24 from './Close24.tsx';
import Close24Circle from './Close24Circle.tsx';
import Close40 from './Close40.tsx';
import Close48 from './Close48.tsx';

type CloseProps = {
    variation: '20' | '20Circle' | '24' | '24Circle' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Close20,
    Close20Circle,
    Close24,
    Close24Circle,
    Close40,
    Close48,
};

const Close: FC<CloseProps> = ({ variation, ...props }) => {
    const variationKey = `Close${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Close" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Close;
